/* eslint-disable object-curly-newline */

// Address
export const OWNER_OF_SERVICE = 'Owner of this service'
export const NOT_OWNER_OF_SERVICE = 'Does not own this service'

// Stages
export const STAGE_CHECK_ADDRESS = 'check_address'
export const STAGE_CLARIFY_ADDRESS = 'clarify_address'
export const STAGE_WAITLIST = 'waitlist'
export const STAGE_OWNER_CHECK = 'owner_check'
export const STAGE_PLAN_SELECT = 'plan_select'
export const STAGE_MODEM_SELECT = 'modem_delivery'
export const STAGE_PERSONAL = 'personal'
export const STAGE_IDENTIFICATION = 'identification'
export const STAGE_PAYMENT = 'payment'
export const STAGE_SUBMIT = 'submit'
export const STAGE_SUCCESS = 'success'

export const STAGES = [
  { id: STAGE_CHECK_ADDRESS, visible: false },
  { id: STAGE_OWNER_CHECK, visible: false },
  { id: STAGE_PLAN_SELECT, visible: false },
  { id: STAGE_MODEM_SELECT, gaId: 1 },
  { id: STAGE_PERSONAL, gaId: 2 },
  { id: STAGE_IDENTIFICATION, gaId: 3 },
  { id: STAGE_PAYMENT, gaId: 4 },
  { id: STAGE_SUBMIT, visible: false, gaId: 5 },
  { id: STAGE_SUCCESS, visible: false },
]

// APIS
export const API_PAYMENT_URL = '/api/signup/pay/'
export const API_MODEM_URL = '/api/signup/modem_select/'
export const API_PERSONAL_URL = '/api/signup/personal/'
export const API_ADDRESS_CHECK_URL = '/api/signup/address_check/'
export const API_ADDRESS_UPDATE_URL = '/api/signup/address_multiple_addresses/'
export const API_LANDLINE_URL = '/api/signup/owner/'
export const API_SUBMIT_URL = '/api/signup/submit/'
export const API_TRANSITION_URL = '/api/signup/transition/'
export const API_ORDER_SUMMARY_URL = '/api/order/summary/'

// Payment
export const DEFAULT_RESPONSE_ERROR = 'Sorry, there was an error processing your payment. Please try again'
export const DEFAULT_RESPONSE_DECLINED = (
  'Sorry, your payment was not successful. Please try again with a different card'
)

// Personal
export const DEFAULT_DETAILS_PROVIDED = {
  first_name: '',
  middle_name: '',
  last_name: '',
  email: '',
  date_of_birth: '',
}

// Multi address stage
export const DEFAULT_MULTI_ADDRESS_STAGE_NUMBER_OF_ADDRESSES_TO_SHOW = 5
export const ADDRESS_CLARIFICATION = 'clarify_address' // const on backend

export const PLAN_4G_FEATURE = 'FHW-4G'



// WEBPACK FOOTER //
// ./containers/Checkout/constants.js